import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';

function LegendBlock({ item }) {
  return (
    <Stack direction="row" spacing={0.5}>
      <item.Icon {...item.iconProps} />
      <Typography variant="subtitle2">{item.name}</Typography>
    </Stack>
  );
}

export default LegendBlock;
